import {isEmpty} from "@pg-mono/nodash";

import {OfferType} from "../../offer/types/OfferType";

export function stringifySearchFormType(offerType: OfferType[]): string {
    const defaultLabel = "Mieszkania, Domy";

    if (isEmpty(offerType)) {
        return defaultLabel;
    }

    return offerType
        .map((type) => {
            if (type === OfferType.HOUSE) {
                return "Domy";
            }
            if (type === OfferType.COMMERCIAL) {
                return "Lokale użytkowe";
            }

            return "Mieszkania";
        })
        .join(", ");
}
import {isEmpty} from "@pg-mono/nodash";

import {OfferType} from "../../offer/types/OfferType";

export function stringifySearchFormType(offerType: OfferType[]): string {
    const defaultLabel = "Mieszkania, Domy";

    if (isEmpty(offerType)) {
        return defaultLabel;
    }

    return offerType
        .map((type) => {
            if (type === OfferType.HOUSE) {
                return "Domy";
            }
            if (type === OfferType.COMMERCIAL) {
                return "Lokale użytkowe";
            }

            return "Mieszkania";
        })
        .join(", ");
}
